import React from "react";
import styled from "styled-components";

const SpanStyles = styled.span`
  --bgRGB: 255, 0, 0;
  --fgRGB: 0, 255, 0;

  display: inline-block;
  text-indent: -9999em;
  /* margin: 50px auto; */
  /* width: 11em; */
  /* height: 11em; */
  border-radius: 50%;
  background: linear-gradient(
    to right,
    rgba(var(--fgRGB), 1) 10%,
    rgba(var(--fgRGB), 0) 42%
  );
  position: relative;
  animation: load3 1.4s infinite linear;
  transform: translateZ(0);

  &:before {
    width: 50%;
    height: 50%;
    background: rgb(var(--fgRGB));
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
  }
  &:after {
    background: rgb(var(--bgRGB));
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: "";
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  @keyframes load3 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default function Spinner({ className }) {
  return <SpanStyles className={className} />;
}
